import { render, staticRenderFns } from "./settle-choose.vue?vue&type=template&id=25a11ae9&scoped=true"
import script from "./settle-choose.vue?vue&type=script&lang=js"
export * from "./settle-choose.vue?vue&type=script&lang=js"
import style0 from "./settle-choose.vue?vue&type=style&index=0&id=25a11ae9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a11ae9",
  null
  
)

export default component.exports